// constants

import { LocationsActionTypes } from "./constants";

export interface LocationActionType {
  type:
    | LocationsActionTypes.API_RESPONSE_SUCCESS
    | LocationsActionTypes.API_RESPONSE_ERROR
    | LocationsActionTypes.GET_LOCATIONS
    | LocationsActionTypes.UPDATE_LOCATIONS
    | LocationsActionTypes.DELETE_LOCATIONS
    | LocationsActionTypes.ADD_LOCATIONS
    | LocationsActionTypes.CLEAR_ERROR;

  payload: {} | string;
}

export interface AddLocationPayload {
  id?: string;
  name: string;
  latitude: number;
  longitude: number;
  address: string;
  phone: string;
  starting_hour: string;
  ending_hour: string;
  is_active: boolean;
}

export interface UpdateLocationPayload {
  id: string;
  data: any;
}

// common success
export const LocationsApiResponseSuccess = (actionType: string, data: any | {}): LocationActionType => ({
  type: LocationsActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});

// common error
export const LocationsApiResponseError = (actionType: string, error: string): LocationActionType => ({
  type: LocationsActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

// get locations
export const getLocations = (status?: string, page?: number, limit?: number): LocationActionType => ({
  type: LocationsActionTypes.GET_LOCATIONS,
  payload: { status, page, limit },
});

export const deleteLocations = (id: string): LocationActionType => ({
  type: LocationsActionTypes.DELETE_LOCATIONS,
  payload: {
    id,
  },
});

export const updateLocation = (
  id: string,
  name: string,
  latitude: number,
  longitude: number,
  address: string,
  phone: string,
  starting_hour: string,
  ending_hour: string,
  is_active: boolean,
  code?: any
): LocationActionType => ({
  type: LocationsActionTypes.UPDATE_LOCATIONS,
  payload: {
    id,
    name,
    latitude,
    longitude,
    address,
    phone,
    starting_hour,
    ending_hour,
    is_active,
    code,
  },
});

// add location
export const addLocation = (
  name: string,
  latitude: number,
  longitude: number,
  address: string,
  phone: string,
  starting_hour: string,
  ending_hour: string,
  is_active: boolean,
  code?: any
): LocationActionType => ({
  type: LocationsActionTypes.ADD_LOCATIONS,
  payload: {
    name,
    latitude,
    longitude,
    address,
    phone,
    starting_hour,
    ending_hour,
    is_active,
    code,
  },
});

// clear error
export const clearLocationError = (): LocationActionType => ({
  type: LocationsActionTypes.CLEAR_ERROR,
  payload: {},
});
